import React, { useState, useEffect } from "react";
import { ICourseDogSessions, IDog } from "@eagerdog/interfaces";

import DogPortrait from "src/components/DogPortrait/DogPortrait";
import Icon from "src/components/Icon/Icon";

import styles from "./DogSelection.module.scss";

interface IProps {
  dogs: ISelectedDog[],
  onChange?: (dogs: ISelectedDog[]) => void;
  onAddDog?: () => void;
  onEditDog?: () => void;
  isAdmin?: boolean;
}

export interface ISelectedDog extends IDog {
  selected: boolean;
  sessions: ICourseDogSessions[]
}

const DogSelection: React.FC<IProps> = (props) => {
  const [dogs, setDogs] = useState<ISelectedDog[]>(props.dogs);

  useEffect(() => {
    setDogs(props.dogs);
  }, [props.dogs]);

  return (
    <div className={styles.DogSelection}>
      <ul className={styles.dogList}>
        {dogs.map((dog) => {
          return (
            <li onClick={() => {
              setDogs(dogs.map(d => d._id === dog._id ? { ...d, selected: !d.selected } : d));

              if (props.onChange) {
                props.onChange(dogs.map(d => d._id === dog._id ? { ...d, selected: !d.selected } : d));
              }
            }} key={dog._id} className={`${styles.dog}` + (dog.selected ? `${styles.selected}` : "")}>
              <DogPortrait className={dog.selected ? `${styles.selected}` : `${styles.notSelected}`} key={dog._id} dog={dog} showName={true} edit={true} onEditDog={props.onEditDog} isAdmin={props.isAdmin} />
            </li>
          );
        })}
        <li onClick={() => { if (props.onAddDog) { props.onAddDog(); } }} className={styles.addDog}>
          <div className={styles.circle}><Icon className={styles.plusIcon} type="plus" /></div>
          <div className={styles.label}><span>Add New Dog</span></div>
        </li>
      </ul>
    </div>  
  );
};

export default DogSelection;
